import {
  color,
  ColorProps,
  compose,
  DisplayProps,
  layout,
  ResponsiveStyleValue,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { cursor, CursorProps } from './cursor'
import { textTransform, TextTransformProps } from './textTransform'
import { TypoSizeProps, typoSizes } from './typoSizes'
import { whiteSpace, WhiteSpaceProps } from './whiteSpace'
import { wordBreak, WordBreakProps } from './wordBreak'
import { wordWrap, WordWrapProps } from './wordWrap'

export type TypoProperty = 'default' | 'heading' | 'buttons'

export interface TypoProps
  extends TypoSizeProps,
    TypographyProps,
    ColorProps,
    SpaceProps,
    WhiteSpaceProps,
    TextTransformProps,
    CursorProps,
    DisplayProps,
    WordBreakProps,
    WordWrapProps {
  variant?: ResponsiveStyleValue<TypoProperty>
}

const defaultProps = withDefaultProps<TypoProps>({
  variant: 'default',
  typoSize: 'base',
})

export const Typo = styled.div.attrs<TypoProps>(defaultProps)(
  variant({
    scale: 'Typo',
    variants: {
      default: {},
      heading: {
        fontFamily: 'header',
      },
      buttons: {
        fontFamily: 'buttons',
      },
    },
  }),
  typoSizes,
  compose(
    whiteSpace,
    wordWrap,
    wordBreak,
    textTransform,
    cursor,
    typography,
    color,
    space,
    layout,
  ),
)
